import React, {useContext, useMemo, useState} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {DatePicker, Select, Table} from "antd";
import dayjs from "dayjs";
import {useGetPlayerPartnerLog} from "../usePlayerData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";

const EVENT_TYPES = [
    {label: '우정도 획득', value: 'RQPartnerBondUp'},
    {label: '말랑지수 획득', value: 'RQPartnerStaminaUp'},
    {label: '파트너 미션 완료', value: 'RQPartnerMissionComplete'},
    {label: '파트너 아이템 획득', value: 'RQPartnerItemGain'},
];

const PlayerPartnerLog = () => {
    const {playerData} = useContext(PlayerContext);
    const [eventType, setEventType] = useState('RQPartnerBondUp');
    const [dateRange, setDateRange] = useState([
        dayjs().subtract(1, 'month').startOf('day'),
        dayjs().endOf('day'),
    ]);

    const begin = dateRange[0].unix();
    const end = dateRange[1].unix();

    const {data: rows, isLoading, error} = useGetPlayerPartnerLog({
        pid: playerData.pid,
        eventType,
        begin,
        end,
    });

    const parsedRows = useMemo(() =>
        (rows || []).map(row => {
            try {
                const logData = JSON.parse(row.logString) ?? {};
                return {...row, ...logData};
            } catch {
                return row;
            }
        }),
        [rows]
    );

    const itemIdTitle = useMemo(() => {
        if (eventType === 'RQPartnerBondUp' || eventType === 'RQPartnerStaminaUp') return '캐릭터 ID';
        if (eventType === 'RQPartnerMissionComplete') return '미션 아이디';
        return 'itemId';
    }, [eventType]);

    const showValueColumns = eventType !== 'RQPartnerMissionComplete';

    const columns = useMemo(() => [
        {title: 'logType', dataIndex: 'logType', key: 'logType'},
        {title: itemIdTitle, dataIndex: 'itemId', key: 'itemId'},
        ...(showValueColumns ? [
            {title: '', dataIndex: 'updatedValue', key: 'updatedValue'},
            {title: 'lastValue', dataIndex: 'lastValue', key: 'lastValue'},
        ] : []),
        {
            title: 'created',
            dataIndex: 'created',
            key: 'created',
            width: 160,
            render: (created) => dayjs.unix(created).format('YYYY-MM-DD HH:mm:ss'),
        },
    ], [itemIdTitle, showValueColumns]);

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
            <div style={{display: 'flex', gap: 8}}>
                <Select
                    value={eventType}
                    onChange={setEventType}
                    options={EVENT_TYPES}
                    style={{width: 240}}
                />
                <DatePicker.RangePicker
                    value={dateRange}
                    onChange={(dates) => dates && setDateRange(dates)}
                    showTime
                />
            </div>
            {isLoading ? <IsLoading/> :
                error ? <ErrorPage error={error}/> :
                    <Table
                        columns={columns}
                        dataSource={parsedRows}
                        rowKey="seq"
                        size="small"
                        bordered
                    />
            }
        </div>
    );
};

export default PlayerPartnerLog;
